export const highlightDifferences = (text1, text2) => {
    const words1 = text1.split(' ');
    const words2 = text2.split(' ');

    return words1.map((word, index) => {
        if (word !== words2[index]) {
            return `<span style="background-color: #ffdd57;">${word}</span>`;
        }
        return word;
    }).join(' ');
};
